import { render } from "./dialog-edit.vue?vue&type=template&id=ffe4208a&ts=true"
import script from "./dialog-edit.vue?vue&type=script&lang=ts"
export * from "./dialog-edit.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__